import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.client.search.adminSortFields,
	columnFields: constants.client.search.adminColumnFields,
	standardFilterFields: constants.client.search.adminStandardFilterFields,
	dateFilterFields: [] as const,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
